<template>
  <Btn
    class="BtnApproval ib sm"
    :class="{
      danger: !isApproved && shouldApprove,
      success: isApproved || !shouldApprove,
      inv: !isApproved,
    }"
    :icon="isApproved ? 'check' : null"
    @click="toggleApprovedAt">
    {{ label }}
  </Btn>
</template>

<script>
export default {
  props: {
    approvedAt: { type: Date },
    shouldApprove: { type: Boolean },
  },
  computed: {
    isApproved() {
      return !!this.approvedAt
    },
    label() {
      if (this.approvedAt) return this.$t('approved')
      if (this.shouldApprove) return this.$t('shouldApprove')

      return this.$t('approvedNot')
    },
  },
  methods: {
    toggleApprovedAt() {
      const approvedAt = this.approvedAt
        ? null
        : new Date()

      this.$up('approvedAt', approvedAt)
    },
  },
}
</script>

<style lang="scss">
.BtnApproval {
}
</style>

<i18n>
{
  "en": {
    "approved": "Approved",
    "approvedNot": "Not approved",
    "shouldApprove": "Needs approval"
  }
}
</i18n>
